var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    xmlnsv: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 0H.75C.3 0 0 .3 0 .75v16.5c0 .45.3.75.75.75h16.5c.45 0 .75-.3.75-.75V.75c0-.45-.3-.75-.75-.75zM5.325 15.375H2.7V6.75h2.7v8.625h-.075zM3.975 5.55C3.15 5.55 2.4 4.875 2.4 3.975c0-.825.675-1.575 1.575-1.575.825 0 1.575.675 1.575 1.575S4.875 5.55 3.975 5.55zm11.4 9.825h-2.7v-4.2c0-.975 0-2.25-1.35-2.25-1.425 0-1.575 1.05-1.575 2.175v4.275h-2.7V6.75H9.6v1.2c.375-.675 1.2-1.35 2.55-1.35 2.7 0 3.225 1.8 3.225 4.125v4.65z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.c3126c6c3a9cf37a9c37ac790ad83212.svg";
export { ForwardRef as ReactComponent };